import { useState } from "react";
//--------------------------------------------------------------------------------------------
import TransferSelect from "src/components/common/transferSelect";
import {
    myAxios, 
    MyFormData, 
    getTimeStamp, 
    getDatefromWeekNum
} from "src/components/common/functions";
import PerDiemForm from "./perDiemForm";
//--------------------------------------------------------------------------------------------
export default function Detail({ 
    setPerDiems, 
    perDiem, 
    history, 
    path1, 
    path2, 
    path3, 
    users, 
    projects, 
    perDiems, 
    notify, 
    voidPerDiem, 
    curWeekStart, 
    curWeekEnd, 
    setShowLoader, 
    user, 
}){
    //--------------------------------------------------------------------------------------------
    const [comments, setComments] = useState(perDiem.approverNotes || "");
    const [showTransferSelect, setShowTransferSelect] = useState(false);
    //--------------------------------------------------------------------------------------------
    return(
    <div className = "border rounded p-2">
        <div className = "d-flex">
            <div className = "flex-grow-1">
                <table className = "table table-fixed noTopBorder">
                    <tbody>
                        <tr>
                            <th>Submit Time</th>
                            <td>
                                <span className = "ml-3">{perDiem.submitTime}</span>
                            </td>
                        </tr>
                        {perDiem.dateUpdated?
                        <tr>
                            <th>Update Time</th>
                            <td>
                                <span className = "ml-3">{perDiem.dateUpdated}</span>
                            </td>
                        </tr>
                        :null}
                        <tr>
                            <th>Notes</th>
                            <td style = {{whiteSpace: "pre-wrap"}}>{perDiem.notes}</td>
                        </tr>
                        {perDiem.notify?
                        <tr>
                            <th>Notified at</th>
                            <td>{perDiem.notify}</td>
                        </tr>
                        :<></>}
                        {perDiem.void === "yes"?<tr>
                            <th>Void Reason</th>
                            <td>{perDiem.voidReason}</td>
                        </tr>:null}
                    </tbody>
                </table>
            </div>
            <div className = "flex-grow-1">
                <table className = "table table-fixed noTopBorder">
                <colgroup>
                    <col/>
                </colgroup>
                    <tbody>
                        <tr>
                            <th>Review Time</th>
                            <th>{perDiem.approvalTime}</th>
                        </tr>
                        <tr>
                            <th>Approver Comments</th>
                            <th className = "text-prewrap">{perDiem.approverNotes}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        {perDiem.void === "yes"?<></>:
        <div className = "text-right mb-3">
            <button type = "button" className = "btn btn-danger mx-3" id = {perDiem.perDiemHashKey} onClick = {voidPerDiem}>Void</button>
            <button type = "button" className = "btn btn-primary mx-3" onClick = {() => history.push(`/${path1}/${path2}/Edit`)}>Edit</button>
            {(perDiem.status !== "Submitted" && perDiem.status !== "Re-Submitted") || perDiem.approverEmail === user.email?<></>:
            <button type = "button" className = "btn btn-info mx-3" id = {perDiem.perDiemHashKey} onClick = {notify}>Notify Approver</button>
            }
        </div>}
        {perDiem.void !== "yes" && perDiem.approverEmail === user.email && perDiem.status !== "Approved" && perDiem.status !== "Rejected"?<>
        <div>
            <button type = "button" className = "btn btn-warning m-3" onClick = {() => {
                setShowTransferSelect(true);
            }}>Forward Approval</button>
        </div>
        {showTransferSelect?
        <TransferSelect
            users = {users}
            closeIt = {() => setShowTransferSelect(false)}
            handleSubmit = {async e => {
                e.preventDefault();
                const formData = new MyFormData(e.currentTarget);
                const forward = JSON.parse(formData.get("forward"));
                if(!forward.email){
                    window.alert("Select an approver first.");
                    return;
                }
                formData.append("perDiemHashKey", perDiem.perDiemHashKey);
                formData.append("forwardEmail", forward.email);
                formData.append("start", getDatefromWeekNum(curWeekStart, 0));
                formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
                //-------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("perDiem/forward.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------
                history.push(`/${path1}`);
                setPerDiems(curWeekStart, curWeekEnd, res.data);
                setShowTransferSelect(false);
            }}
        />
        :<></>}
        <div className = "mx-3">
            <label htmlFor = "approverNotes" className = "font-weight-bold mb-0">Approver Comments:</label>
            <textarea id = "approverNotes" className = "form-control" rows = {4} value = {comments} onChange = {e => {setComments(e.currentTarget.value)}} name = "comments"/>
        </div>
        <div>
            {[
                {title:"Approve", decision:"Approved", word: "approve", color: "btn-success"}, 
                {title:"Reject", decision:"Rejected", word: "reject", color: "btn-danger"}
            ].map((item, itemIndex) => 
            <button type = "button" key = {itemIndex} className = {`btn ${item.color} m-3`} decision = {item.word} onClick = {async() => {
                if(item.word === "reject" && !comments){
                    window.alert("Comments are required for rejection.");
                    return;
                }
                if(!window.confirm(`Are you sure to ${item.word} this per diem?`)) return;
                
                const formData = new MyFormData();
                formData.append("perDiemHashKey", perDiem.perDiemHashKey);
                formData.append("approverDecision", item.decision);
                formData.append("approverNotes", comments);
                //-----------------------------------
                setShowLoader(true);
                const res = await myAxios("perDiem/approval.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-----------------------------------
                setPerDiems(
                    curWeekStart, 
                    curWeekEnd, 
                    perDiems.map(thisPerDiem => thisPerDiem.perDiemHashKey === perDiem.perDiemHashKey?{...thisPerDiem, 
                        "status" : item.decision,
                        "approverNotes" : comments,
                        "approvalTime" : getTimeStamp(),
                        "excelId": "", 
                        "formId": res.data
                    }:thisPerDiem)
                );               
            }}>{item.title}</button>)}
        </div>
        </>:null}
        {path3 === "Edit" && users.length && projects.length?
        <PerDiemForm
            keyword = "Update"
            history = {history}
            closeIt = {() => history.push(`/${path1}/${path2}`)}
            curWeekStart = {curWeekStart}
            curWeekEnd = {curWeekEnd}
            setPerDiems = {setPerDiems}
            users = {users} 
            projects = {projects}
            perDiems = {perDiems}
            {...perDiem}
        />:null}
    </div>
    )
}